import React from "react";
import { Link, useLocation } from "react-router-dom";

const Footer = () => {
  const location = useLocation();
  const server_folder = localStorage.getItem("server_folder");

  const menuItems = [
    {
      path: "/",
      icon: `${server_folder}/img/footer/Home.png`,
      activeIcon: `${server_folder}/img/footer/homeactive.png`,
      text: "Home",
    },
    {
      path: "/search",
      icon: `${server_folder}/img/footer/search.png`,
      activeIcon: `${server_folder}/img/footer/searchactive.png`,
      text: "Search",
    },
    {
      path: "/profile",
      icon: `${server_folder}/img/footer/Profile.png`,
      activeIcon: `${server_folder}/img/footer/profileactive.png`,
      text: "Profile",
    },
    {
      path: "/more",
      icon: `${server_folder}/img/footer/more.png`,
      activeIcon: `${server_folder}/img/footer/moreactive.png`,
      text: "More",
    },
  ];

  return (
    <div className="bottom-panel">
      {menuItems.map((item, index) => (
        <div key={index} className="bp-col">
          <Link
            to={item.path}
            className={location.pathname === item.path ? "active" : ""}
          >
            <div className="bp-icon">
              <img
                src={
                  location.pathname === item.path ? item.activeIcon : item.icon
                }
                alt="icon"
              />
            </div>
            <div
              className="bp-text"
              style={{
                color: location.pathname === item.path ? "#D9613B" : "white",
              }}
            >
              {item.text}
            </div>
          </Link>
        </div>
      ))}
    </div>
  );
};

export default Footer;
